module.exports = __webpack_public_path__ + "static/media/notes.a9f6232b.svg";